import { selectIsNZ } from '@/context/display';
import { store } from '@/context/store';

export function isMobile(mobile: string | null | undefined): boolean {
    if (mobile === null || mobile === undefined) return false;
    const state = store.getState();
    const isNZ = selectIsNZ(state);
    const reAU = /^04[0-9]{8}$/g;
    const reNZ = /^(02|03|04|06|07|09)[0-9]{7,9}$/g;
    return (isNZ ? reNZ : reAU).test(String(mobile));
}
